import React, { useState, useContext, useEffect } from "react"
import ROSLIB from "roslib"
import Context from "../utils/Context"
import api from "../api/api"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPowerOff, faAndroid, faRobot, faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import BatteryStatus from "./BatteryStatus"
import DiagnosticStatus from "./DiagnosticStatus"

export default function RobotButtons({ robot }) {
  const context = useContext(Context)

  // state
  const [isLoading, setIsLoading] = useState(false)
  
  // select robot
  const selectRobot = async (robot) => {
    console.log('connecting to ', robot)
    context.actions.setModalState({ ...context.modalState, settingsRemote: false })

    if (context.robotInfos[robot].ros !== 'ROS2') {
      let newActions = context.availableActions.map((action) => {
        action.needsValue = action.needs_value
        delete action.needs_value
        return action
      })

      context.actions.setAvailableActions(newActions)
    }

    console.log(context.robotInfos[robot].ip.split(':')[1].slice(2))
    context.actions.setSelectedRobot({ name: robot, ip: context.robotInfos[robot].ip.split(':')[1].slice(2), typeRobot: 'Generic', ROS: context.robotInfos[robot].ros })
    connectRobot({ name: robot, ip: context.robotInfos[robot].ip.split(':')[1].slice(2), typeRobot: 'Generic', ROS: context.robotInfos[robot].ros })
    context.actions.setSelectedTypeRobot('Generic')
    // get robot info from FMS, if using it
    if (context.settings.fmsConnection) {
      try {
        const robotInfo = async () => {
          api.getRobotInfo(robot)
            .then((res) => {
              // console.log("got fms robot info", res.data[0])
              context.actions.setRobotInfo(res.data[0])
            }).catch((error) => {
              context.actions.setErrorMessage(error.response.status)
              context.actions.setModalState({ ...context.modalState, disconnect: true })
            })
        }

        robotInfo()

        // context.actions.setRobotInfo(robotInfo.data[0])
      } catch (error) {
        console.log("RobotSelection: login error ", error)
      }
    }

  }

  // connect selected robot ip address to ROS
  const connectRobot = (robot) => {
    if (!context.isRobotConnected && robot) {
      context.actions.setAcceleratorValue(50)
      setIsLoading(true)
      //window.connectionInterval = setInterval(() => {

      if (!window.rosConnected) {
        window.ros = new ROSLIB.Ros({ url: context.robotInfos[robot.name].ip })

        window.ros.on("connection", () => {
          console.log(
            "Connected to websocket server.",
            context.robotInfos[robot.name].ip
          )
          window.rosConnected = true
          context.actions.setIsRobotConnected(true)
          setIsLoading(false)
        })

        window.ros.on("error", function (error) {

          disconnect()
          context.actions.setErrorMessage("disconnect")
          context.actions.setModalState({ ...context.modalState, disconnect: true })
          console.log("Error connecting to websocket server")
          //clearInterval(window.connectionInterval)

        })

        window.ros.on("close", function () {

          console.log("Connection to websocket server closed.")
          setIsLoading(false)
          disconnect()
        })
      }
      //}, 10000)
    }
  }

  const disconnect = () => {

    //clearInterval(window.connectionInterval)
    window.ros.close()
    window.rosConnected = false
    context.actions.setSelectedRobot(false)
    context.actions.setSelectedTypeRobot(null)
    context.actions.setIsRobotConnected(false)
  }

  return (
    <div className="field has-addons">
      <div className="control is-expanded">
        <div className="is-fullwidth">
          <div className="control columns">
            <div className="column">
              <button
                type="submit"
                className={isLoading && !(context.selectedRobot && (context.selectedRobot?.name !== robot)) ? "button is-link is-warning is-loading"
                  : context.isRobotConnected && context.selectedRobot?.name === robot ? "button is-danger" : "button is-warning is-inverted"}
                onClick={() => (context.selectedRobot ? disconnect() : selectRobot(robot))}
                disabled={context.selectedRobot && (context.selectedRobot?.name !== robot) ? "disabled" : ""}
              >
                <div className="icon is-small">
                  <FontAwesomeIcon icon={context.isRobotConnected && context.selectedRobot?.name === robot ? faPowerOff : faRobot} className="fas" />
                </div>

                <div>
                  {context.isRobotConnected && context.selectedRobot?.name === robot ? "Disconnect " + context.selectedRobot?.name : isLoading && context.selectedRobot?.name === robot ? "Connection..."
                    : robot}
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
